import React, { useMemo } from 'react';
import { Modal } from '@mantine/core';
import AddProcurementManagerForm from './AddProcurementManagerForm';
import AddStoreManagerForm from './AddStoreManagerForm';
import MoveStoreManagerForm from './MoveStoreManagerForm';
import { ProcurementExecutive } from '../../codegen/graphql';
import { useUserPortal } from '../../context/UserPortalContext';

type Props = Readonly<{
    executives?: ProcurementExecutive[];
}>;

function TeamsModal({ executives }: Props) {
    const {
        teamsModal: {
            procurementExecutive,
            movingStoreManager,
            addingStoreManager,
            addingProcurementManager,
            store,
            storeManager,
            opened,
        },
        closeTeamsModal,
    } = useUserPortal();

    const title = useMemo(() => {
        if (movingStoreManager) {
            return 'Move Store Manager';
        }
        if (addingStoreManager) {
            return 'Add Store Manager';
        }
        if (addingProcurementManager) {
            return 'Add Procurement Manager';
        }
        return '';
    }, [movingStoreManager, addingStoreManager, addingProcurementManager]);

    const content = useMemo(() => {
        if (movingStoreManager) {
            return (
                <MoveStoreManagerForm
                    currentStoreId={store?.id ?? ''}
                    storeManager={storeManager}
                    close={closeTeamsModal}
                />
            );
        }
        if (addingStoreManager && store) {
            return (
                <AddStoreManagerForm
                    close={closeTeamsModal}
                    storeManager={storeManager}
                    store={store}
                />
            );
        }
        if (addingProcurementManager) {
            const procurementExecutiveId = procurementExecutive?.id ?? '';

            return (
                <AddProcurementManagerForm
                    executives={executives}
                    procurementExecutiveId={procurementExecutiveId}
                    close={closeTeamsModal}
                />
            );
        }
        return null;
    }, [
        movingStoreManager,
        addingStoreManager,
        addingProcurementManager,
        store,
        storeManager,
        procurementExecutive,
        executives,
        closeTeamsModal,
    ]);

    return (
        <Modal
            title={title}
            opened={opened}
            onClose={closeTeamsModal}
            classNames={{
                title: 'text-primary font-semibold text-lg',
                content: 'overflow-visible',
            }}
            size="lg"
            keepMounted={false}
        >
            {content}
        </Modal>
    );
}

export default TeamsModal;
